import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Table, TableModule } from "primeng/table";
import { BcLedgerStacker } from "../../../../core/models/bcLedger/bcLedgerStacker";
import { MiscData } from "../../../../core/models/bcLedger/misc/MiscData";
import { MiscRequestDto } from "../../../../core/models/bcLedger/misc/MiscRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { MoveToFreightComponent } from "../move-to-freight/move-to-freight.component";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { FreightsData } from "../../../../core/models/bcLedger/freightsResponseDto";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
@UntilDestroy()
@Component({
  selector: "jni-misc",
  templateUrl: "./misc.component.html",
  styleUrls: ["./misc.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    MoveToFreightComponent,
    HidedynamicsdatePipe,
    ButtonModule,
    InputTextModule,
  ],
})
export class MiscComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  miscLists: MiscData[] = [];
  miscSelected!: FreightsData;
  bcledgerFilter!: MiscRequestDto;
  total!: number;
  fileName = "Misc";
  display = false;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _route: ActivatedRoute,
    private _miscService: BcledgerService,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService
  ) {
    this._route.params.subscribe(params => {
      this.bcledgerFilter = { ...params } as MiscRequestDto;
    });
  }

  ngOnInit(): void {
    this.getMiscData();
  }

  getMiscData() {
    this._loaderService.setLoaderState(true);
    this._miscService
      .getMiscData(this.bcledgerFilter)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data.Data) {
            this.miscLists = res.data.Data;
            this.total = res.data.Total;
          } else {
            this._toastr.error("Error", res.message || "No results found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "No results found");
        },
      });
  }

  moveToFreightStatus(event: boolean) {
    if (event) {
      this.getMiscData();
    }
    this.display = false;
    this.miscSelected = {} as FreightsData;
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    exportExcel(this.miscLists, this.fileName);
  }

  moveToFreight() {
    this.display = true;
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.bcledgerFilter = { ...this.bcLedgerStacker };
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
